import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ReimbursementService } from '../reimbursement.service';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { FlashService } from '../../flash/flash.service';
@Component({
  selector: 'app-reimbursement-admin-view',
  templateUrl: './reimbursement-admin-view.component.html',
  styleUrls: ['./reimbursement-admin-view.component.css']
})
export class ReimbursementAdminViewComponent implements OnInit {
  public userData;
  sub;
  id;
  date;
  user;
  reimbursement_manager;
  accepted;
  constructor(private reimbur: ReimbursementService, private route: ActivatedRoute,
    private location: Location, public router: Router, private flashService: FlashService
  ) {
    this.user = JSON.parse(localStorage.getItem('currentUser'));
    this.user.roles.forEach(roles => {
      if (roles == 'reimbursement_manager') {
        this.reimbursement_manager = roles;
      }
    });
    this.reimbur.getListStatus().subscribe(status => {
      status.filter(status => {
        if (status.key === "paid") {
          this.accepted = status.key;
        }
      });
    });
  }
  trackByFn(index) {
    return index;
  }
  ngOnInit() {
    this.userData = this.reimbur.reimbursementUserList;
    this.sub = this.route.params.subscribe(params => {
      this.id = params['id'];

    });
    this.userData.items.forEach(data => {
      this.date = data.date;
    });
  }
  goToFile(url) {
    window.location.replace(url);
  }
  locationBack() {
    this.location.back();
  }
  downloadReport(reimbursementId) {
    this.reimbur.getReportFile(reimbursementId).subscribe((blob: Blob) => {
      const fileName = "report.pdf";
      if (navigator.msSaveBlob) {
        navigator.msSaveBlob(blob, fileName);
      }
      else {
        let link = document.createElement("a");
        if (link.download !== undefined) {
          let url = URL.createObjectURL(blob);
          link.setAttribute("href", url);
          link.setAttribute("download", fileName);
          link.style.visibility = 'hidden';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      }
    });
  }

  managerAccept(id, list) {
    let final = {
      items: []
    }
    list.items.forEach(itemsData => {
      const itemsPayload = {
        _id: itemsData._id,
        approval_cost: itemsData.cost
      }
      final.items.push(itemsPayload);
    });

    this.reimbur.getAccept(final, id, this.accepted).subscribe(accepted => {
      this.flashService.show(accepted['message'], 'alert-success');
      this.router.navigate(['/reimbursement/admin/list']);
    });
  }

}



// WEBPACK FOOTER //
// /home/bharath/agira-projects/asmart/agira-intranet-ui/src/app/reimbursement/reimbursement-admin-view/reimbursement-admin-view.component.ts